export default "__VITE_ASSET__CQH7FCvf__"